import { getMessagesControl } from 'providers/Toast';

export const MESSAGES = getMessagesControl({
  changeError: (t) => ({
    title: t('error-while-executing-date-change-request'),
    description: t('try-again-in-a-few-moments') as string,
    type: 'error',
  }),

  changeSuccess: (t) => ({
    title: t('task-expected-date-changed'),
    type: 'success',
  }),

  changeRejectSuccess: (t) => ({
    title: t('task-expected-date-was-not-changed'),
    type: 'success',
  }),
});
